'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Fridge = function (_React$Component) {
    _inherits(Fridge, _React$Component);

    function Fridge() {
        _classCallCheck(this, Fridge);

        return _possibleConstructorReturn(this, (Fridge.__proto__ || Object.getPrototypeOf(Fridge)).apply(this, arguments));
    }

    _createClass(Fridge, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M5.538 30.305h.265v.848c0 .467.38.847.847.847s.848-.38.848-.847v-.848h10.597v.848c0 .467.38.847.846.847.47 0 .85-.38.85-.847v-.848h.264c1.402 0 2.544-1.14 2.544-2.542V2.545c0-1.402-1.14-2.544-2.544-2.544H5.537C4.135 0 2.993 1.14 2.993 2.546v25.218c0 1.402 1.142 2.542 2.544 2.542zM4.69 2.545c0-.468.38-.85.85-.85h14.514c.467 0 .847.38.847.85v7.946H4.69V2.545zm0 9.64h16.212v15.577c0 .465-.38.847-.847.847H5.538c-.468 0-.848-.383-.848-.848V12.186z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M7.128 4.027c-.468 0-.847.38-.847.848v2.967c0 .467.38.847.848.847s.848-.38.848-.848V4.875c0-.468-.38-.848-.848-.848zM7.128 22.676c.468 0 .848-.38.848-.847v-7.207c0-.468-.38-.848-.848-.848-.468 0-.847.38-.847.848v7.206c0 .467.38.846.848.846z' })
            );
        }
    }]);

    return Fridge;
}(_react2.default.Component);

Fridge.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Fridge;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/fridge.js
// module id = 1102
// module chunks = 0